(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsNewEventController', CmsNewEventController);

  /* ngInject */
  function CmsNewEventController($state, Flash, agencyTypes, cmsEventService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.agencyTypes = agencyTypes;
    vm.createEvent = createEvent;
    vm.event = {
      // Lisa requested the status field to be removed, so default to 'published' so events show
      agency: null,
      status: 'published',
      event_type: 'regulatory',
      proposal_status: 'proposed'
    };
    vm.eventForm = {};

    function createEvent() {
      vm.clearFormErrors(vm.eventForm);
      cmsEventService(sessionService.getAuthToken()).save(vm.event, _createEventSuccess, _createEventFailure);
    }

    function _createEventSuccess(response) {
      Flash.create('success', 'The event was successfully created.');
      $state.go('application.compliance_services.cms_edit_event', {id: response.id});
    }

    function _createEventFailure(response) {
      vm.setFormErrors(vm.eventForm, response);
      Flash.create('danger', 'An error occurred with the submission, please correct the errors on the form and resubmit.');
    }
  }
})();
